import { render, staticRenderFns } from "./PredicateList.vue?vue&type=template&id=a61c0ff4&"
import script from "./PredicateList.vue?vue&type=script&lang=js&"
export * from "./PredicateList.vue?vue&type=script&lang=js&"
import style0 from "./PredicateList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports